"use strict";
import { tns } from "tiny-slider";

export default function () {
    const valid = document.querySelector(".o-challenges-slider__container");
    if (valid) {
        const slider = tns({
            container: ".o-challenges-slider__container",
            slideBy: 1,
            controls: false,
            nav: true,
            navPosition: "bottom",
            gutter: 12,
            loop: true,
            items: 1,
            center: true,
            touch: true,
            mouseDrag: true,
            responsive: {
                1024: {
                    items: 3,
                },
            },
        });

        const arrowLeft = document.querySelector(".o-challenges .arrows-left");
        arrowLeft.addEventListener("click", () => {
            slider.goTo("prev");
        });
        const arrowRight = document.querySelector(
            ".o-challenges .arrows-right"
        );
        arrowRight.addEventListener("click", () => {
            slider.goTo("next");
        });
    }
}
